import React from 'react';
import { AppBarSection, Menu, MenuItem } from '@progress/kendo-react-layout';
import { FpFormattedMessage } from 'locales/FpFormattedMessage';
import { useNavigate } from 'react-router-dom';
import { fpProjectInvitationLinkBuilder } from 'utils/FpProjectInvitaionLinkBuiilder';
import { fpGroupManagerLinkBuilder } from 'utils/FpGroupManagerLinkBuiilder';
import { useIntl } from 'hooks/intl';
import styles from './style.module.scss';

export type FpHeaderMenuProps = {
  projectId: string;
  projectName: string
  projectTypeName: string
  projectStatus: string
  isProjectAdmin: boolean
  isFpReadableProject: boolean
  isFpEditableProject: boolean
  isEditableExtendedAttributeProject: boolean
  anySubsystemServiceOpened: boolean
  isProjectInvitationServiceAuth: boolean
  isGroupManagerServiceAuth: boolean
}

export function FpHeaderMenu(props: FpHeaderMenuProps) {
  const navigate = useNavigate();

  const intl = useIntl();

  const handleMenu = (e: any) => {
    if (!e.item.data) {
      return;
    }
    if (e.item.data.route) {
      navigate(e.item.data.route);
      return;
    }
    if (!e.item.data?.open) {
      return;
    }
    switch (e.item.data.open) {
      case 'project_invite': {
        window.open(fpProjectInvitationLinkBuilder(props.projectId), '_blank', 'noopener');
        break;
      }
      case 'group_manager': {
        window.open(fpGroupManagerLinkBuilder(props.projectId), '_blank', 'noopener');
        break;
      }
    }
  };

  const projectDiscriptionRendar = (label: string) => (
    <div className={styles.header__description}>
      {label}
    </div>
  );

  // 管理者メニューを出す条件
  // ログインユーザが管理者であること、かつ、選択中のプロジェクトが編集可能であること
  const allowEditMenuShow = props.isProjectAdmin && props.anySubsystemServiceOpened;

  return (
    <AppBarSection style={{ flexShrink: 1, overflow: 'hidden' }}>
      { props.isFpReadableProject && (
        <Menu onSelect={handleMenu}>
          <MenuItem cssClass={styles.header__title} text={props.projectName}>
            <MenuItem linkRender={() => projectDiscriptionRendar(props.projectName as string)} cssClass={styles.header__menuItem} />
            <MenuItem linkRender={() => projectDiscriptionRendar(props.projectTypeName as string)} cssClass={styles.header__menuItem} />
            <MenuItem linkRender={() => projectDiscriptionRendar(intl.formatMessage(`label.project_status.${props.projectStatus}`))} cssClass={styles.header__menuItem} />
            <MenuItem render={() => <FpFormattedMessage id="link.top" />} data={{ route: '/' }} />
            <MenuItem render={() => <FpFormattedMessage id="link.projectDetail" />} data={{ route: '/project' }} />
            <MenuItem render={() => <FpFormattedMessage id="link.projectSwitch" />} data={{ route: '/project_select' }} />
            { allowEditMenuShow && <MenuItem cssStyle={{ borderTop: '1px solid #333', height: 0 }} /> }
            { allowEditMenuShow && <MenuItem disabled={!props.isFpEditableProject} render={() => <FpFormattedMessage id="link.layout" />} data={{ route: '/admin/layout_role_assign' }} /> }
            { allowEditMenuShow && <MenuItem disabled={!props.isEditableExtendedAttributeProject} render={() => <FpFormattedMessage id="link.attr" />} data={{ route: '/admin/extended_attribute' }} /> }
            { allowEditMenuShow && <MenuItem disabled={!props.isFpEditableProject} render={() => <FpFormattedMessage id="link.search" />} data={{ route: '/admin/search' }} /> }
            { (props.isProjectInvitationServiceAuth || props.isGroupManagerServiceAuth) && <MenuItem cssStyle={{ borderTop: '1px solid #333', height: 0 }} />}
            { props.isProjectInvitationServiceAuth && <MenuItem render={() => <FpFormattedMessage id="service.pjInvite" />} data={{ open: 'project_invite' }} /> }
            { props.isGroupManagerServiceAuth && <MenuItem render={() => <FpFormattedMessage id="service.groupManager" />} data={{ open: 'group_manager' }} /> }
          </MenuItem>
        </Menu>
      ) }
    </AppBarSection>
  );
}
